import { render, staticRenderFns } from "./ComponentItem.vue?vue&type=template&id=353bded6&"
import script from "./ComponentItem.vue?vue&type=script&lang=js&"
export * from "./ComponentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports